// react
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';

// components
import LoadingPage from '@karehero/llama/components/pages/Loading/Loading';

// hooks
import { useAuth } from 'hooks';

/**
 * Authenticate is a component that renders the authentication page.
 */
export const Authenticate = () => {
  // hooks
  const navigate = useNavigate();
  const { isLoading } = useAuth();

  // effects
  useEffect(() => {
    // wait until the authentication with Kinde is complete before redirecting
    if (isLoading) return;

    // redirect to / - the root route will handle the redirection based on the tenant state
    navigate(ROUTES.HOME);
  }, [isLoading, navigate]);

  return <LoadingPage />;
};

Authenticate.displayName = 'Authenticate';
export default Authenticate;
